module.exports = __webpack_public_path__ + "img/people.b249d5db.png";